import './bigpigbarbecue/style';
import FormStructure from './bigpigbarbecue/form_structure';

export default FormStructure;



// WEBPACK FOOTER //
// /Users/leila/dev/inquiry-renderer/client_forms/includes.js